import styled from 'styled-components';
import theme from '../../theme/theme';
import { Box, Button } from "@mui/material";

export const Container = styled.div`
    margin: 0 4rem;
`;

export const StyledModalContent = styled(Box)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 50%;
  max-height: 700px;
  overflow: auto;
  background-color: ${theme.color.white};
  box-shadow: 24px;
  padding: 20px;;
  border-radius: 8px;

  @media (max-width: 844px) {
    width: 80%;
  }
`;

export const CrossContainer = styled.div`
    position: absolute;
    top: 20px;
    right: 20px;
    cursor: pointer;
`;

export const HeaderContainer = styled.h1`
    font-size: 32px;
    color: ${theme.color.navy};
    margin-bottom: 20px;
`;

export const AttributeContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const InputsContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 20px;

    @media (max-width: 768px) {
        flex-direction: column;
        justify-content: center;
        gap: 0;
    }
`;